import { Dispatch } from "redux";
import { openModal } from "libs/modals";
import { getDraftsFromStorage } from "./draft-storage";
import { DRAFT_RESTORATION_MODAL } from "./bulk-create-post.model";

/**
 * Checks for unsaved drafts in localStorage and shows restoration modal if found
 *
 * This function should be called once on app load (from root.tsx)
 * - Retrieves drafts from localStorage (includes automatic TTL cleanup)
 * - Validates drafts belong to current user (prevents cross-user contamination)
 * - If drafts exist, opens the restoration modal via Redux
 * - Modal allows user to restore all drafts or discard them
 *
 * Restoration flow:
 * 1. User clicks "Restore" → dispatches restoreDrafts action
 * 2. Saga rehydrates form state from serialized data
 * 3. Opens bulk create modal with all restored forms
 *
 * @param dispatch - Redux dispatch function (use dependency injection)
 * @param userId - Current user ID for validation (prevents cross-user drafts)
 */
export function checkAndShowDraftRestoration(
  dispatch: Dispatch,
  userId?: string
) {
  const drafts = getDraftsFromStorage(userId); // Includes TTL cleanup and user validation

  if (!drafts || drafts.length === 0) {
    // No drafts found, nothing to do
    return;
  }

  // Show restoration modal with draft data
  dispatch(
    openModal({
      type: DRAFT_RESTORATION_MODAL,
      props: { drafts },
    })
  );
}
